export default __webpack_public_path__ + "static/media/employee-directory.c0e45dfe.svg";